var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RequisitionCreation"},[_c('RequisitionOptions',{on:{"changes-status-update":_vm.onOptionStatusChange}}),_c('div',{staticClass:"RequisitionSetup"},[_c('RequisitionTableSamples')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }